import MkApolloProvider from '../../../utils/MkApolloProvider';
import CorporateActionsCalendar from './CorporateActionsCalendar.vue';
import CorporateActionsStockTransfers from './CorporateActionsStockTransfers.vue';

/**
 * 株式分割一覧表示用のルートコンポーネント
 * @module CorporateActions/CorporateActionsStockTransfer
 */
const CorporateActionsStockTransfer = {
  el: '#v-corporate-action-stock-transfer',
  apolloProvider: MkApolloProvider,
  components: {
    CorporateActionsCalendar,
    CorporateActionsStockTransfers,
  },
}

export default CorporateActionsStockTransfer;
